import { render } from "./PreregisteredRow.vue?vue&type=template&id=52f72b6c&scoped=true"
import script from "./PreregisteredRow.vue?vue&type=script&lang=js"
export * from "./PreregisteredRow.vue?vue&type=script&lang=js"

import "./PreregisteredRow.vue?vue&type=style&index=0&id=52f72b6c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-52f72b6c"

export default script